export default "__VITE_ASSET__c338247d__"